var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleCrosses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 458,
    viewBox: "0 0 325 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.167 313V338",
    stroke: "#5600F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.667 325.5L95.667 325.5",
    stroke: "#5600F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.167 0V12",
    stroke: "#5600F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.167 6L102.167 6",
    stroke: "#5600F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319.001 366V378",
    stroke: "#5600F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M325.001 372L313.001 372",
    stroke: "#5600F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M319.001 0V12",
    stroke: "#5600F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M325.001 6L313.001 6",
    stroke: "#5600F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 60V72",
    stroke: "#5600F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 66L-1.19209e-07 66",
    stroke: "#5600F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216.834 114V139",
    stroke: "#5600F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M229.334 126.5L204.334 126.5",
    stroke: "#5600F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.834 446V458",
    stroke: "#5600F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.834 452L210.834 452",
    stroke: "#5600F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCrosses);
export default __webpack_public_path__ + "static/media/purple-crosses.7eddc1e1cda47a7bf0f0d6736871c6df.svg";
export { ForwardRef as ReactComponent };